export const SEARCH_DATA_SIZE = 10
export const PROJECT_NAME = 'Ticket Tracking System'
export const QUERY_PREFIX = '?q='
export const AM = 'a';
export const PM = 'p';
export const HOURS_IN_A_DAY = 24;
export const HOUR_INTERVAL_RANGE = 3;
export const FEET_IN_A_MILE = 5280;
export const DEFAULT_COORDINATES = { latitude: 40.001671, longitude: -83.019726 }
export const STYLESHEET_LENGTH = document && document.styleSheets ? document.styleSheets.length : 99